/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ENAX){
	const a = 'is-active';
	const $path = location.pathname;

	// フローリストのアクティブ化
	const serviceFlow = () => {
		if($('.js-flow-item').length) {
			$('.js-flow-item').each((idx,ele) => {
				if($(ele).attr('href') === $path) {
					$(ele).addClass(a);
				}
			})
		}
	};

	// ============================================
	serviceFlow();

})(window.jQuery, window.ENAX);
